export default {"list":"_list_1s5bf_1","wrapper":"_wrapper_1s5bf_21"};